import React from 'react';
import { FaBell, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Header.css';

export default function Header() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    return (
        <header className="header">
            <div className="header-content">
                <div className="header-search">
                    <input
                        type="text"
                        placeholder="Search..."
                        className="search-input"
                    />
                </div>
                <div className="header-right">
                    <div className="notifications">
                        <FaBell className="icon" />
                        <span className="notification-badge">3</span>
                    </div>
                    <div className="user-profile">
                        <div className="profile">
                            <FaUserCircle className="icon" />
                            <span>{user?.displayName || 'User'}</span>
                        </div>
                        <button onClick={handleLogout} className="logout-btn" title="Logout">
                            <FaSignOutAlt />
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
}
